module.exports = __webpack_public_path__ + "img/undraw_Login_re_4vu2.303e4a67.svg";